import produce from 'immer';

import { createReducer, getErrorStatus, getInitialStatus, getPendingStatus } from '../utils';

import { CREATE_POLICY, DELETE_POLICY, FETCH_ALL_POLICIES, FETCH_ONE_POLICY, UPDATE_POLICY } from './actions';
import type { PolicyStore } from './store';

const initialState = {
  policies: {},
  status: getInitialStatus(),
};

export default createReducer<PolicyStore>(initialState, {
  [`${FETCH_ALL_POLICIES}_PENDING`]: (state) => {
    return produce(state, draftState => {
      draftState.status = getPendingStatus();
    });
  },

  [`${FETCH_ALL_POLICIES}_REJECTED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getErrorStatus(action.payload);
    });
  },

  [`${FETCH_ALL_POLICIES}_FULFILLED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getInitialStatus();
      (action.payload.data || []).forEach(policy => {
        draftState.policies[policy.id] = policy;
      });
    });
  },

  [`${FETCH_ONE_POLICY}_PENDING`]: (state) => {
    return produce(state, draftState => {
      draftState.status = getPendingStatus();
    });
  },

  [`${FETCH_ONE_POLICY}_REJECTED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getErrorStatus(action.payload);
    });
  },

  [`${FETCH_ONE_POLICY}_FULFILLED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getInitialStatus();
      draftState.policies[action.meta.id] = action.payload.data;
    });
  },

  [`${UPDATE_POLICY}_PENDING`]: (state) => {
    return produce(state, draftState => {
      draftState.status = getPendingStatus();
    });
  },

  [`${UPDATE_POLICY}_REJECTED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getErrorStatus(action.payload);
    });
  },

  [`${DELETE_POLICY}_PENDING`]: (state) => produce(state, draftState => {
    draftState.status = getPendingStatus();
  }),
  [`${DELETE_POLICY}_FULFILLED`]: (state, action) => produce(state, draftState => {
    draftState.status = getInitialStatus();
    delete draftState.policies[action.meta.id];
  }),
  [`${DELETE_POLICY}_REJECTED`]: (state, action) => produce(state, draftState => {
    draftState.status = getErrorStatus(action.payload);
  }),

  [`${UPDATE_POLICY}_FULFILLED`]: (state, action) => {
    return produce(state, draftState => {
      draftState.status = getInitialStatus();
      const current = draftState.policies[action.payload.data.id];
      draftState.policies[action.payload.data.id] = { ...current, ...action.payload.data };
    });
  },

  [`${CREATE_POLICY}_PENDING`]: (state) => produce(state, draftState => {
    draftState.status = getPendingStatus();
  }),
  [`${CREATE_POLICY}_FULFILLED`]: (state, action) => produce(state, draftState => {
    draftState.status = getInitialStatus();
    draftState.policies[action.payload.data.id] = action.payload.data;
  }),
  [`${CREATE_POLICY}_REJECTED`]: (state, action) => produce(state, draftState => {
    draftState.status = getErrorStatus(action.payload);
  }),
});
